import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonIconSmComponent } from '@new-core/components/buttons-game/button-icon-sm/button-icon-sm.component';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { IconButtonComponent } from '@new-core/components/buttons-game/icon-button/icon-button.component';
import { PlayButtonComponent } from '@new-core/components/buttons-game/play-button/play-button.component';
import { ArrowButtonComponent } from '@pages/games/game/game-instance/arrow-button/arrow-button.component';
import { BackgroundButtonComponent } from '@pages/games/game/game-instance/background-choose/background-button/background-button.component';

@Component({
  selector: 'ms-game-material-pack',
  imports: [
    CommonModule,
    ArrowButtonComponent,
    BackgroundButtonComponent,
    ButtonIconSmComponent,
    IconButtonComponent,
    GameButtonComponent,
    PlayButtonComponent,
  ],
  templateUrl: './game-material-pack.component.html',
  styleUrls: ['./game-material-pack.component.scss'],
})
export class GameMaterialPackComponent {}
